export const hideZendeskButton = (): void => {
  // @ts-ignore
  if (window.zE) {
    // @ts-ignore
    window.zE(function () {
      // @ts-ignore
      window.zE.hide();
    });
  }
};
